"use client"

import styled from "@emotion/styled"
import Image from "next/image"
import Container from "ui/Container"
import { extractProperty } from "utils"
import { getUmbracoMediaUrl } from "utils/getUmbracoMediaUrl"

const StyledContainer = styled.div`
  width: 100%;
  padding: 32px 0;
  display: flex;
  justify-content: center;
  ${({ theme }) => theme.breakpoints.up("md")} {
    justify-content: unset;
    padding: 48px 0;
  }
`

export default function Logo({ data }: { data: any }) {
  const logo = extractProperty(data, "logo")
  return (
    <Container paddingMobile={true}>
      <StyledContainer>
        <Image
          src={getUmbracoMediaUrl(logo)}
          alt={"אגד"}
          width={222}
          height={80}
        />
      </StyledContainer>
    </Container>
  )
}
